(ns app.front.view.group.admin.templates
  (:require [app.domain.committee.model :as committee-model]
            [app.domain.group.model :as group-model]
            [app.domain.group.permit-type-config.model :as ptc-model]
            [app.domain.util :as du]
            [app.front.ui :as ui]
            [app.front.ui.select :as ui-select]
            [app.front.ui.tabs :as ui-tabs]
            [app.front.ui.text-button :as ui-text-button]
            [app.front.ui.typography :refer [h3]]
            [app.front.util :refer [for-all for-frag]]
            [app.front.view.committees.admin :as admin.committees]
            [app.front.view.group.admin.common :as acommon]
            [app.front.view.group.admin.files :as group-files]
            [app.front.view.group.admin.form-pdf-config :as form-pdf]
            [app.front.view.group.admin.inspections.order-template :as order-template-editor]
            [app.front.view.group.admin.inspections.pdf-template-editor :as pdf-template-editor]
            [app.front.view.group.admin.phrases :as phrases]
            [app.front.view.group.admin.subs :as gas]
            [app.front.view.group.admin.templates.stamps.core :as stamps]
            [app.front.view.group.admin.templates.subs :as template-subs]
            [app.front.view.group.admin.templates.system-email :as system-email]
            [app.front.view.group.admin.verdict-template.edit :as verdict-template-edit]
            [app.i18n.model :as i18n-model]
            [clojure.set :as set]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub >evt]]
            [core.front.feature-flags :as ff]
            [core.front.href :as href]
            [core.permission.resolver :as permission-resolver]
            [core.util.util :as util]
            [potpuri.core :as p]
            [re-frame.core-instrumented :as rf]
            [reagent.core :as r]))

(defn- tab-href [group-id tab]
  (href/href :view/group.admin.templates
             {:group-id group-id}
             (case tab
               :system-email-template/system-emails {:tab system-email/system-email-tab-param}
               :stamp/stamps {:tab stamps/stamps-tab-param}
               nil)))

(defn template-link-list [{:keys [tr title templates]}]
  [:div
   [h3 "mb-2 text-lg" (tr [title])]
   [:table.w-full
    [:tbody
     (for-frag [{:keys [link text copy-fn remove-fn status]} templates]
       [:tr
        {:class-name (if (= status :disabled) "italic" "")}
        [:td
         (if link
           (cc/link {:href       link
                     :aria-label (tr [:admin/view-template]
                                     [text])}
                    text)
           [:span.leading-tight text])]
        [:td.w-24.pl-3
         (when (some? remove-fn)
           [ui/modal-confirmation-button
            {:trigger-button-text (tr [:remove])
             :text-button?        true
             :tr                  tr
             :id                  (str "remove-template-" text)
             :on-yes-click        remove-fn
             :trigger-button-opts {:aria-label (str (tr [:remove]) " " text)}}])]
        [:td.w-20.pl-3
         (when (some? copy-fn)
           [ui-text-button/text-button {:on-click   copy-fn
                                        :aria-label (str (tr [:copy]) " " text)} (tr [:copy])])]])]]])

(defn add-template-link [{:keys [on-add href]} content]
  [:div.mt-4
   (cc/link (-> {:href (or href "#")}
                (p/assoc-if :on-click on-add))
            content)])

(defn select-permit-type [tr *permit-type props children]
  [:div.mt-4
   [ui/modal-confirmation-button
    (merge {:text-button?        true
            :yes-disabled?       (nil? @*permit-type)
            :tr                  tr
            :id                  "add-new-template"
            :trigger-button-opts {:aria-label (str (tr [:add]) " ")}}
           props)
    children]])

(defn permit-templates [tr group-id superdomain-id link-fn]
  (r/with-let [*permit-type (r/atom nil)]
    (let [permit-types       (<sub [::gas/group-primary-permit-types])
          templates          (<sub [::template-subs/templates
                                    group-id
                                    superdomain-id
                                    {:entity-type  :entity.type/verdict-template
                                     :permit-types permit-types}
                                    tr
                                    :verdict.template/name])
          has-templates?     (seq templates)
          superdomain-group? (<sub [::gas/superdomain-group?])
          can-add-templates? (or (<sub [::gas/has-permit-type? ptc-model/permit-types-with-permit-templates])
                                 superdomain-group?)]
      (when (or has-templates? can-add-templates?)
        [:div
         (when has-templates?
           [template-link-list
            {:tr        tr
             :title     :admin/permit-templates
             :templates (for [template templates]
                          {:text      (:verdict.template/name template)
                           :status    (when (du/in-state? :verdict-template.state/disabled template)
                                        :disabled)
                           :link      (link-fn template)
                           :remove-fn (when (and (= group-id (-> template :domain/authority-group :db/id))
                                                 (not (<sub [::verdict-template-edit/template-used-in-express-issuance?
                                                             (:db/id template)])))
                                        #(>evt [::verdict-template-edit/delete group-id (:db/id template)]))
                           :copy-fn   #(>evt [::verdict-template-edit/copy group-id (:db/id template)])})}])
         (when can-add-templates?
           (if superdomain-group?
             [select-permit-type tr *permit-type
              {:trigger-button-text (tr [:verdict.template/create-default])
               :on-yes-click        #(>evt [::verdict-template-edit/create-for-permit-type group-id @*permit-type])}
              [:div
               [:p (tr [:verdict.template/create-default])]
               [:p (tr [:verdict.template/select-product])]
               [ui-select/select
                {:id           "new-template's-permit-type"
                 :val->str     #(tr [%])
                 :value        @*permit-type
                 :on-change    #(reset! *permit-type %)
                 :allow-empty? false
                 :values       permit-types}]]]
             [add-template-link
              {:on-add #(>evt [::verdict-template-edit/create-default group-id])}
              (tr [:verdict.template/create-default])]))]))))

(defn planning-templates [tr group-id link-fn]
  (let [draft-template (<sub [::template-subs/template group-id :entity.type/planning-draft-report-template])
        final-template (<sub [::template-subs/template group-id :entity.type/planning-final-report-template])]
    (when (or draft-template final-template)
      [template-link-list
       {:tr        tr
        :title     :admin/planning-report-templates
        :templates (->> [(when draft-template
                           {:text (tr [:planning-reports/draft-report-template])
                            :link (link-fn draft-template)})
                         (when final-template
                           {:text (tr [:planning-reports/final-report-template])
                            :link (link-fn final-template)})]
                        (remove nil?))}])))

(defn fee-receipt-templates [tr group-id link-fn]
  (let [superdomain-group? (<sub [::gas/superdomain-group?])
        templates          (<sub [::template-subs/fee-templates group-id])]
    (when (seq templates)
      [template-link-list
       {:tr        tr
        :title     :admin/fees-templates
        :templates (->> templates
                        (map (fn [template]
                               {:text (if superdomain-group?
                                        (str (tr [(:receipt-template/subtype template) (:entity/type template)])
                                             (when-let [pt (:template/permit-type template)]
                                               (str " (" (tr [pt]) ")")))
                                        (tr [(:receipt-template/subtype template) (:entity/type template)]))
                                :link (link-fn template)}))
                        (sort-by :text))}])))

(defn inspection-pdf-templates [tr group-id superdomain-id link-fn]
  [:div
   [template-link-list
    {:tr        tr
     :title     :inspection.pdf-template/title
     :templates (for-all [template (<sub [::template-subs/templates group-id superdomain-id {:entity-type :entity.type/inspection-pdf-template} tr :inspection.pdf-template/name])]
                  {:text      (:inspection.pdf-template/name template)
                   :remove-fn (when (= group-id (-> template :domain/authority-group :db/id))
                                #(>evt [::pdf-template-editor/delete-pdf-template (:db/id template)]))
                   :copy-fn   #(>evt [::pdf-template-editor/copy-pdf-template group-id template])
                   :link      (link-fn template)})}]
   [add-template-link
    {:href (href/href :view/group.admin.template.new
                      (util/mmap {:template-type :inspection-pdf-template} group-id))}
    (tr [:template-editor/add-new-pdf-template])]])

(defn order-templates [tr group-id superdomain-group link-fn]
  [:div
   [template-link-list
    {:tr        tr
     :title     :order/templates
     :templates (->> (<sub [::template-subs/templates group-id (:db/id superdomain-group) {:entity-type :entity.type/order-template}])
                     (filter du/is-active?)
                     (map (fn [{:order.template/keys [name] :as template}]
                            (let [inherited? (boolean (some-> template :domain/authority-group :db/id (not= group-id)))]
                              {:text      (cond-> (i18n-model/get-text name (<sub [:language]))
                                            inherited?
                                            (str " (" (:group/name superdomain-group) ")"))
                               :remove-fn (when-not inherited?
                                            #(>evt [::order-template-editor/delete-order-template (:db/id template)]))
                               :copy-fn   #(>evt [::order-template-editor/copy-order-template template group-id])
                               :link      (link-fn template)})))
                     (sort-by :text))}]
   [add-template-link
    {:href (href/href :view/group.admin.template.new
                      (util/mmap {:template-type :order-template} group-id))}
    (tr [:template-editor/add-new-order-pdf-template])]])

(defn meeting-agenda-templates [tr group-id]
  (when-let [committees (seq (<sub [::admin.committees/committees]))]
    [template-link-list
     {:tr        tr
      :title     :committee-meeting/agenda-templates
      :templates (for-all [committee committees]
                   {:text (committee-model/committee-name committee (<sub [:language]))
                    :link (href/href :view/group.admin.committee-agenda-template
                                     {:committee-id (:db/id committee)
                                      :group-id     group-id})})}]))

(defn public-notice-templates [tr group-id link-fn]
  (let [public-notice-template (<sub [::template-subs/template group-id :entity.type/public-notice-template])]
    (when public-notice-template
      [template-link-list
       {:tr        tr
        :title     :group-admin/public-notice-templates
        :templates [{:text (tr [:group-admin/public-notice-template])
                     :link (link-fn public-notice-template)}]}])))

(defn letter-templates [tr group-id superdomain-id]
  (let [copy-enabled? (<sub [::ff/enabled? :feature-flag.id/copy-letter-templates])]
    [:div
     [template-link-list
      {:tr        tr
       :title     :group-admin/letter-templates
       :templates (->> (<sub [::template-subs/templates group-id superdomain-id {:entity-type :entity.type/letter-pdf-template} tr :letter-pdf-template/name])
                       (map (fn [template]
                              {:text      (:letter-pdf-template/name template)
                               :copy-fn   (when copy-enabled?
                                            #(>evt [::template-subs/copy-letter-template group-id (:db/id template)]))
                               :remove-fn (when (= group-id (-> template :domain/authority-group :db/id))
                                            #(>evt [::template-subs/remove-letter-template (:db/id template)]))
                               :link      (template-subs/template-href group-id template)})))}]
     [add-template-link
      {:href (href/href :view/group.admin.template.new
                        (util/mmap {:template-type :letter-pdf-template} group-id))}
      (tr [:template-editor/add-new-letter-template])]]))

(defn licence-revocation-letter-templates [tr group-id link-fn]
  (when-let [templates (seq (<sub [::template-subs/templates group-id nil {:entity-type :entity.type/licence-revocation-letter-template} tr]))]
    [template-link-list
     {:tr        tr
      :title     :admin/revocation-letter-templates
      :templates (->> templates
                      (map (fn [template]
                             {:text (tr [(:entity/type template)])
                              :link (link-fn template)}))
                      (sort-by :text))}]))

(rf/reg-event-fx ::open-create-page
  (fn [_ [_ group-id permit-type]]
    {:route/replace {:route  :view/group.admin.new.template.permit-type
                     :params {:group-id      group-id
                              :permit-type   (name permit-type)
                              :template-type :package-pdf-template}}}))

(defn package-templates [tr group-id superdomain-group]
  (r/with-let [*permit-type (r/atom nil)]
    (let [permit-types (<sub [::gas/group-permit-types])]
      [:div
       [template-link-list
        {:tr        tr
         :title     :group-admin/package-templates
         :templates (->> (<sub [::template-subs/templates
                                group-id
                                (:db/id superdomain-group)
                                {:entity-type  :entity.type/package-pdf-template
                                 :permit-types permit-types}
                                tr
                                :package-pdf-template/name])
                         (map (fn [template]
                                {:text      (:package-pdf-template/name template)
                                 :status    (when (du/in-state? :package-pdf-template.state/disabled template)
                                              :disabled)
                                 :link      (template-subs/template-href group-id template)
                                 :remove-fn (when (= group-id (-> template :domain/authority-group :db/id))
                                              #(>evt [::template-subs/remove-package-template (:db/id template)]))})))}]
       (if (<sub [::gas/superdomain-group?])
         [select-permit-type tr *permit-type
          {:trigger-button-text (tr [:verdict.template/create-default])
           :on-yes-click        #(>evt [::open-create-page group-id @*permit-type])}
          [:div
           [:p (tr [:verdict.template/create-default])]
           [:p (tr [:verdict.template/select-product])]
           [ui-select/select
            {:id           "new-template's-permit-type"
             :val->str     #(tr [%])
             :value        @*permit-type
             :on-change    #(reset! *permit-type %)
             :allow-empty? false
             :values       (set/intersection permit-types
                                             (:group.feature/admin-package group-model/permit-types-for-feature))}]]]
         [add-template-link
          {:href (href/href :view/group.admin.template.new
                            (util/mmap {:template-type :package-pdf-template} group-id))}
          (tr [:template-editor/add-new-package-pdf-template])])])))

(defn- domain-template-content [tr group-id]
  [:section
   [:h2 (tr [:admin/templates])]
   [system-email/list-view tr group-id]])

(defn- template-content [tr group-id superdomain-id superdomain-group inspections? orders-for-inspections? court-packages?
                         show-phrases? link-fn]
  [:<>
   [:section
    [:h2 (tr [:group-admin/verdict-templates])]
    [:div.grid.grid-cols-1.md:grid-cols-2.gap-8
     [permit-templates tr group-id superdomain-id link-fn]
     [planning-templates tr group-id link-fn]
     [fee-receipt-templates tr group-id link-fn]
     [public-notice-templates tr group-id link-fn]
     [meeting-agenda-templates tr group-id]
     [letter-templates tr group-id superdomain-id]
     [licence-revocation-letter-templates tr group-id link-fn]]
    (when inspections?
      [:div.mt-8.grid.grid-cols-1.md:grid-cols-2.gap-8
       [inspection-pdf-templates tr group-id superdomain-id link-fn]
       (when orders-for-inspections?
         [order-templates tr group-id superdomain-group link-fn])])
    (when court-packages?
      [:div.mt-8.grid.grid-cols-1.md:grid-cols-2.gap-8
       [package-templates tr group-id superdomain-group]])]
   [:section
    [:h2 (tr [:admin/images])
     [group-files/verdict-template-images group-id]]]
   (when show-phrases?
     [acommon/config-section
      (tr [:group-admin/phrases])
      (tr [:group-admin/phrases-instruction])
      [phrases/phrase-management group-id]])
   [form-pdf/form-pdf-config group-id]])

(defn- email-template-content [tr group-id group]
  [:section
   [system-email/organization-templates-link tr group]
   [system-email/list-view tr group-id]])

(defn- selected-tab [match]
  (let [tab (-> match :parameters :query :tab)]
    (cond
      (= tab stamps/stamps-tab-param) :stamp/stamps
      (= tab system-email/system-email-tab-param) :system-email-template/system-emails
      :else :group-admin/verdict-templates)))

(defn view [match]
  (let [tr                      (<sub [::gas/group-tr])
        group-type              (-> (<sub [::gas/group]) :group/type)
        group-id                (-> match :parameters :path :group-id)
        domain-group?           (= :group.type/domain group-type)
        group-is-superdomain?   (<sub [::gas/superdomain-group?])
        superdomain-group       (when-not group-is-superdomain?
                                  (<sub [::gas/superdomain]))
        superdomain-id          (:db/id superdomain-group)
        inspections?            (or group-is-superdomain?
                                    (<sub [::gas/has-feature? :group.feature/inspections]))
        orders-for-inspections? (or group-is-superdomain?
                                    (<sub [::gas/has-feature? :group.feature/orders-for-inspections-enabled]))
        court-packages?         (or group-is-superdomain?
                                    (<sub [::gas/has-feature? :group.feature/admin-package]))
        system-emails?          (<sub [::ff/enabled? :feature-flag.id/system-email-templates])
        stamps?                 (and (contains? group-model/authority-group-types group-type)
                                     (<sub [::ff/enabled? :feature-flag.id/pdf-markup-tool])
                                     (permission-resolver/permitted? (<sub [::gas/group])
                                                                     (<sub [:session/user])
                                                                     :permission.group/admin))
        show-phrases?           (<sub [::ff/disabled? :feature-flag.id/standard-texts-admin-view])
        group                   (<sub [::gas/group])
        link-fn                 (partial template-subs/template-href group-id)]
    [:<>
     (if domain-group?
       (if system-emails?
         [acommon/admin-page-v2
          {:match           match
           :title           :admin/templates
           :wait-for-group? true}
          [acommon/section-title-wrapper {:title (tr [:system-email-template/system-emails])}
           [domain-template-content tr group-id]]]
         [acommon/admin-page-v2
          {:match           match
           :title           :admin/templates
           :wait-for-group? true}
          [acommon/section-title-wrapper {:title (tr [:admin/templates])}]])
       (if (or system-emails? stamps?)
         (let [tabs         (cond-> [:group-admin/verdict-templates]
                              system-emails? (conj :system-email-template/system-emails)
                              stamps? (conj :stamp/stamps))
               selected-tab (if (some #{(selected-tab match)} tabs)
                              (selected-tab match) :group-admin/verdict-templates)]
           [acommon/admin-page-v2
            {:match           match
             :title           :admin/templates
             :wait-for-group? true
             :header-content  [ui-tabs/tabs
                               {:selected-id selected-tab
                                :aria-label  (tr [:admin/templates])
                                :tabs        (->> tabs
                                                  (map (fn [tab]
                                                         {:id    tab
                                                          :label (tr [tab])
                                                          :href  (tab-href group-id tab)})))}]}
            [acommon/section-title-wrapper {:hide-title? true}
             (case selected-tab
               :group-admin/verdict-templates
               [template-content tr group-id superdomain-id superdomain-group inspections?
                orders-for-inspections? court-packages? show-phrases? link-fn]
               :system-email-template/system-emails
               [email-template-content tr group-id group]
               :stamp/stamps
               ^{:key group-id}
               [stamps/collection-screen tr group-id]
               nil)]])
         [acommon/admin-page-v2
          {:match           match
           :title           :admin/templates
           :wait-for-group? true}
          [acommon/section-title-wrapper {:title (tr [:admin/templates])}
           [template-content tr group-id superdomain-id superdomain-group inspections?
            orders-for-inspections? court-packages? show-phrases? link-fn]]]))]))
